import {Component, OnInit} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";

export type SimpleHelpDialog = {
  readableName: string;
  help: string;
};

@Component({
  templateUrl: "./simple-help-dialog.template.pug",
  providers: [],
})
export class SimpleHelpDialogComponent extends DialogComponent<SimpleHelpDialog, {}>
  implements SimpleHelpDialog, OnInit {
  public error: Error;
  public help;
  public readableName;

  public static show(dialogService: DialogService, model: SimpleHelpDialog): void {
    dialogService.addDialog(SimpleHelpDialogComponent, model, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  ngOnInit(): void {
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
